import {ShowTariffPlans} from './show-tariff-plans';

export default ShowTariffPlans;